import { Component } from 'preact';
import styled from 'styled-components';
import { Link } from 'preact-router'

const NavWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`
const HomeButton = styled(Link)`
    height: 1.56em;
    padding: 0 1.5em;
    border: 1px solid ${props => props.theme.colors.bodyLight};
    border-radius: 0.2em;
    display: flex;
    justify-content: center;

    &:active {
        background: ${props => props.theme.colors.bodyLight};

        & > svg {
            fill: ${props => props.theme.colors.backgroundMid};
        }
    }
`
const HomeIcon = styled.svg`
    width: 1em;
    fill: ${props => props.theme.colors.bodyLight};
`
const TopLevel = styled(Link)`
    height: 1.56em;
    padding: 0 1.5em;
    border: 1px solid ${props => props.theme.colors.backgroundHighlight};
    border-radius: 0.2em;
    line-height: 1.56em;
    text-decoration: none;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;

    span {
        font-size: 0.75em;
        display: block;
        color: ${props => props.theme.colors.backgroundHighlight};
    }
`
const MidLevel = styled(TopLevel)`
    border: 1px solid ${props => props.theme.colors.bodyLight};

    span {
        color: ${props => props.theme.colors.bodyLight};
    }

    &:active {
        background: ${props => props.theme.colors.bodyLight};

        & > span {
            color: ${props => props.theme.colors.bodyLight};
        }
    }
`
const SideArrow = styled.svg`
    width: 0.5em;
    fill: ${props => props.theme.colors.bodyLight};
    transform: rotate(180deg);
    margin: 0 0.5em;
    height: 1em;
`
const CrumbWrapper = styled.div`
    display: flex;
    align-items: center;
`
class Breadcrumbs extends Component {
    renderStoreTitle(category, type) {
        if (!this.props.store || !this.props.store.name.length) {
            return (
                <TopLevel href=''><span>{category}</span></TopLevel>
            )
        } else {
            let storeTitle = '';
            let categoryTitle = '';
            if (this.props.store.name.length > 10) {
                storeTitle = (this.props.store.name.slice(0, 10)) + '...'
            } else {
                storeTitle = this.props.store.name
            }
            if (category.length > 3) {
                categoryTitle = (category.slice(0, 3)) + '...'
            } else {
                categoryTitle = category
            }
            return (
                <CrumbWrapper >
                    <MidLevel href={`/${this.props.superCategorySlug}`}  >
                        <span>{categoryTitle}</span>
                    </MidLevel>
                    <SideArrow
                        id="side-arrow"
                        data-name="side-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 839 775">
                        <path d="M394,97c21-20,41-41,62-61L843,423C714,552,585,682,456,811l-62-62c95-94,189-188,283-282H4V380H677C583,286,489,191,394,97Z" transform="translate(-4 -36)" />
                    </SideArrow>
                    <TopLevel href=''><span>{storeTitle}</span></TopLevel>
                </CrumbWrapper>
            )
        }
    }

    render(props) {
        return (
            <NavWrapper>

                <HomeButton href={`/`} >
                    <HomeIcon
                        id="home-icon"
                        data-name="home-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 211 178">
                        <polygon points="0 91 29 91 29 178 86 178 86 111 124 111 124 178 182 178 182 91 211 91 105 0 0 91" />
                    </HomeIcon>
                </HomeButton>

                <SideArrow
                    id="side-arrow"
                    data-name="side-arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 839 775">
                    <path d="M394,97c21-20,41-41,62-61L843,423C714,552,585,682,456,811l-62-62c95-94,189-188,283-282H4V380H677C583,286,489,191,394,97Z" transform="translate(-4 -36)" />
                </SideArrow>

                {this.renderStoreTitle(props.superCategory, props.type)}

            </NavWrapper>
        );
    }
}

export default Breadcrumbs;





// WEBPACK FOOTER //
// ./components/header/Breadcrumbs.js